var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("參數設定")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("會員卡畫面")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("會員卡畫面")])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "pt-4 border-bottom",
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "lg",
      "label": "表頭",
      "label-class": "font-weight-bold py-1"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "【表頭標題】顯示",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "py-1",
    attrs: {
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.moduleNotFound
    },
    model: {
      value: _vm.headerSection.enable_page_title,
      callback: function callback($$v) {
        _vm.$set(_vm.headerSection, "enable_page_title", $$v);
      },
      expression: "headerSection.enable_page_title"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "【表頭標題】文字",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "【表頭標題】文字",
      "disabled": _vm.moduleNotFound
    },
    model: {
      value: _vm.pageTitle,
      callback: function callback($$v) {
        _vm.pageTitle = $$v;
      },
      expression: "pageTitle"
    }
  }), _c('b-form-text', {
    attrs: {
      "id": "input-live-help"
    }
  }, [_vm._v("若未設定標題，將顯示全域標題")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "【表頭選單】顯示",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "py-1",
    attrs: {
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.moduleNotFound
    },
    model: {
      value: _vm.headerSection.enable_menu_items,
      callback: function callback($$v) {
        _vm.$set(_vm.headerSection, "enable_menu_items", $$v);
      },
      expression: "headerSection.enable_menu_items"
    }
  })], 1), _vm.headerSection.enable_menu_items ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "左選單",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2",
    attrs: {
      "disabled": _vm.moduleNotFound,
      "options": _vm.menuItemOption.map(function (x) {
        return {
          text: x.name,
          value: {
            float: 'left',
            title: x.name,
            type: x.type
          }
        };
      })
    },
    model: {
      value: _vm.headerSection.menu_items[0],
      callback: function callback($$v) {
        _vm.$set(_vm.headerSection.menu_items, 0, $$v);
      },
      expression: "headerSection.menu_items[0]"
    }
  })], 1) : _vm._e(), _vm.headerSection.enable_menu_items ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "右選單",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-select', {
    attrs: {
      "disabled": _vm.moduleNotFound,
      "options": _vm.menuItemOption.map(function (x) {
        return {
          text: x.name,
          value: {
            float: 'right',
            title: x.name,
            type: x.type
          }
        };
      })
    },
    model: {
      value: _vm.headerSection.menu_items[1],
      callback: function callback($$v) {
        _vm.$set(_vm.headerSection.menu_items, 1, $$v);
      },
      expression: "headerSection.menu_items[1]"
    }
  })], 1) : _vm._e()], 1), _c('b-form-group', {
    staticClass: "pt-4 border-bottom",
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "lg",
      "label": "卡片",
      "label-class": "font-weight-bold py-1"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "【會員卡片】顯示",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "py-1",
    attrs: {
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.moduleNotFound
    },
    model: {
      value: _vm.memberCardSection.enable,
      callback: function callback($$v) {
        _vm.$set(_vm.memberCardSection, "enable", $$v);
      },
      expression: "memberCardSection.enable"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "【會員卡片】版型",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2",
    attrs: {
      "options": _vm.cardLayoutOption,
      "disabled": _vm.moduleNotFound
    },
    model: {
      value: _vm.memberCardSection.card_layout,
      callback: function callback($$v) {
        _vm.$set(_vm.memberCardSection, "card_layout", $$v);
      },
      expression: "memberCardSection.card_layout"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "【LOGO】顯示",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('button', {
    staticClass: "\n                  btn btn-link\n                  px-2\n                  text-dark\n                  align-self-start\n                  upload-button\n                ",
    attrs: {
      "disabled": _vm.moduleNotFound
    }
  }, [_c('b-form-file', {
    attrs: {
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": function change($event) {
        return _vm.upload($event);
      }
    }
  }), !!_vm.memberCardSection.logo ? _c('a', {
    staticClass: "btn-sm btn-outline-danger",
    attrs: {
      "disabled": _vm.moduleNotFound
    },
    on: {
      "click": function click($event) {
        _vm.memberCardSection.logo = null;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })]) : _vm._e(), _c('a', {
    attrs: {
      "href": _vm.memberCardSection.logo,
      "target": "_blank"
    }
  }, [_c('small', {
    staticClass: "text-truncate d-inline-block",
    staticStyle: {
      "max-width": "250px"
    }
  }, [_vm._v(" 目前路徑：" + _vm._s(_vm.memberCardSection.logo || "未上傳") + " ")])])], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "【會員名稱】顯示",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "py-1",
    attrs: {
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.moduleNotFound
    },
    model: {
      value: _vm.memberCardSection.display_name,
      callback: function callback($$v) {
        _vm.$set(_vm.memberCardSection, "display_name", $$v);
      },
      expression: "memberCardSection.display_name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "【會員點數】顯示",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "py-1",
    attrs: {
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.moduleNotFound
    },
    model: {
      value: _vm.memberCardSection.display_points,
      callback: function callback($$v) {
        _vm.$set(_vm.memberCardSection, "display_points", $$v);
      },
      expression: "memberCardSection.display_points"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "【會員點數】名稱",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "【會員點數】名稱",
      "disabled": _vm.moduleNotFound
    },
    model: {
      value: _vm.memberCardSection.points_name,
      callback: function callback($$v) {
        _vm.$set(_vm.memberCardSection, "points_name", $$v);
      },
      expression: "memberCardSection.points_name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "【會員條碼】顯示",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "py-1",
    attrs: {
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.moduleNotFound
    },
    model: {
      value: _vm.memberCardSection.display_barcode,
      callback: function callback($$v) {
        _vm.$set(_vm.memberCardSection, "display_barcode", $$v);
      },
      expression: "memberCardSection.display_barcode"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "【個人頭像】顯示",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "py-1",
    attrs: {
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.moduleNotFound
    },
    model: {
      value: _vm.memberCardSection.display_avator,
      callback: function callback($$v) {
        _vm.$set(_vm.memberCardSection, "display_avator", $$v);
      },
      expression: "memberCardSection.display_avator"
    }
  })], 1)], 1), _c('b-form-group', {
    staticClass: "pt-4 border-bottom",
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "lg",
      "label": "選單圖示",
      "label-class": "font-weight-bold py-1"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "【選單圖示】顯示",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "py-1",
    attrs: {
      "value": true,
      "unchecked-value": false,
      "disabled": _vm.moduleNotFound
    },
    model: {
      value: _vm.menuIconSection.enable,
      callback: function callback($$v) {
        _vm.$set(_vm.menuIconSection, "enable", $$v);
      },
      expression: "menuIconSection.enable"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "sm",
      "label": "每列圖示數量",
      "label-class": "font-weight-bold text-lg-right"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2",
    attrs: {
      "options": [1, 2, 3, 4],
      "disabled": _vm.moduleNotFound
    },
    model: {
      value: _vm.menuIconSection.column_number,
      callback: function callback($$v) {
        _vm.$set(_vm.menuIconSection, "column_number", $$v);
      },
      expression: "menuIconSection.column_number"
    }
  })], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('CardReview', {
    attrs: {
      "pageTitle": _vm.pageTitle,
      "headerSection": _vm.headerSection,
      "memberCardSection": _vm.memberCardSection,
      "sections": [_vm.menuIconSection]
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-center mt-3"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取消")]), _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "success",
      "disabled": _vm.isLoading || _vm.moduleNotFound
    },
    on: {
      "click": function click($event) {
        return _vm.handleSubmit(false);
      }
    }
  }, [_vm._v(" 儲存 ")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.isLoading || _vm.moduleNotFound
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" 儲存後關閉 ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }